import React, {useEffect} from "react";
import {getClients} from "../../Services/ApiService";
import {Link} from "react-router-dom";
import {useState} from "@hookstate/core";
import {Table} from "react-bootstrap";

function ClientsList() {
    const apiError = useState(false);
    const clients = useState([]);
    const searchResults = useState([]);

    useEffect(() => {
        getClients(_clients => {
            if (_clients === false) return apiError.set(true);

            clients.set(_clients)
            searchResults.set(_clients);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function onSearchChange(e) {
        searchResults.set(clients.get().filter(client => {
            return client.name.toLowerCase().includes(e.target.value.toLowerCase());
        }));
    }

    if (apiError.get()) {
        return <h4>Unable to reach server.</h4>;
    }

    return (
        <div>
            <input onChange={onSearchChange} placeholder={'Search'} /><br />
            <Link to={`/client/new`}>
                <strong>Add new client</strong>
            </Link>

            <Table id='clientList' bordered size={'sm'}>
                <thead>
                <tr>
                    <th id={'jobNumberCol'}>Name</th>
                    <th id={'clientCol'}>Salesman</th>
                </tr>
                </thead>
                <tbody>
                {searchResults.get().map(client => {
                    return (
                        <tr key={client.id}>
                            <td key={client.id}>
                                <Link to={`/client/${client.id}`}>
                                    {client.name}
                                </Link>
                            </td>
                            <td className={'salesman'}>{client.salesman}</td>
                        </tr>
                    )
                })}
                </tbody>
            </Table>
        </div>
    )
}

export default ClientsList;